export const TRANSLATION_LOADING = "TRANSLATION_LOADING";
export const TRANSLATE_TEXT = "TRANSLATE_TEXT";
export const SET_TRANSLATED_TEXT = "SET_TRANSLATED_TEXT";
export const TRANSLATED_TEXT_ERROR = "TRANSLATED_TEXT_ERROR";
export const DELETE_INPUT_TEXT = "DELETE_INPUT_TEXT";
export const SWAP_SELECTED_LANGUAGES = "SWAP_SELECTED_LANGUAGES";
export const SELECT_LANGUAGE = "SELECT_LANGUAGE";
export const TOGGLE_LANGUAGE_MENU = "TOGGLE_LANGUAGE_MENU";

export const ENGLISH_TO_GEORDIE = "ENGLISH_TO_GEORDIE";
export const GEORDIE_TO_ENGLISH = "GEORDIE_TO_ENGLISH";
export const NON_ENGLISH_TO_GEORDIE = "NON_ENGLISH_TO_GEORDIE";
export const GEORDIE_TO_NON_ENGLISH = "GEORDIE_TO_NON_ENGLISH";

export const API_TRANSLATE =
  "https://api.geordify.com/translate";



// WEBPACK FOOTER //
// ./src/constants/translator.js